var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _excluded = ["list", "setList", "children", "tag", "style", "className", "clone", "onAdd", "onChange", "onChoose", "onClone", "onEnd", "onFilter", "onRemove", "onSort", "onStart", "onUnchoose", "onUpdate", "onMove", "onSpill", "onSelect", "onDeselect"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var $8zHUo$sortablejs = require("sortablejs");
var $8zHUo$classnames = require("classnames");
var $8zHUo$react = require("react");
var $8zHUo$tinyinvariant = require("tiny-invariant");
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function (key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }
    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });
  return dest;
}
$parcel$export(module.exports, "Sortable", function () {
  return $882b6d93070905b3$re_export$Sortable;
});
$parcel$export(module.exports, "Direction", function () {
  return $882b6d93070905b3$re_export$Direction;
});
$parcel$export(module.exports, "DOMRect", function () {
  return $882b6d93070905b3$re_export$DOMRect;
});
$parcel$export(module.exports, "GroupOptions", function () {
  return $882b6d93070905b3$re_export$GroupOptions;
});
$parcel$export(module.exports, "MoveEvent", function () {
  return $882b6d93070905b3$re_export$MoveEvent;
});
$parcel$export(module.exports, "Options", function () {
  return $882b6d93070905b3$re_export$Options;
});
$parcel$export(module.exports, "PullResult", function () {
  return $882b6d93070905b3$re_export$PullResult;
});
$parcel$export(module.exports, "PutResult", function () {
  return $882b6d93070905b3$re_export$PutResult;
});
$parcel$export(module.exports, "SortableEvent", function () {
  return $882b6d93070905b3$re_export$SortableEvent;
});
$parcel$export(module.exports, "SortableOptions", function () {
  return $882b6d93070905b3$re_export$SortableOptions;
});
$parcel$export(module.exports, "Utils", function () {
  return $882b6d93070905b3$re_export$Utils;
});
$parcel$export(module.exports, "ReactSortable", function () {
  return $7fe8e3ea572bda7a$export$11bbed9ee0012c13;
});
function $eb03e74f8f7db1f3$export$1d0aa160432dfea5(node) {
  if (node.parentElement !== null) node.parentElement.removeChild(node);
}
function $eb03e74f8f7db1f3$export$6d240faa51aa562f(parent, newChild, index) {
  var refChild = parent.children[index] || null;
  parent.insertBefore(newChild, refChild);
}
function $eb03e74f8f7db1f3$export$d7d742816c28cf91(customs) {
  $eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
  $eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
}
function $eb03e74f8f7db1f3$export$77f49a256021c8de(customs) {
  customs.forEach(function (curr) {
    return $eb03e74f8f7db1f3$export$1d0aa160432dfea5(curr.element);
  });
}
function $eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs) {
  customs.forEach(function (curr) {
    $eb03e74f8f7db1f3$export$6d240faa51aa562f(curr.parentElement, curr.element, curr.oldIndex);
  });
}
function $eb03e74f8f7db1f3$export$4655efe700f887a(evt, list) {
  var mode = $eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt);
  var parentElement = {
    parentElement: evt.from
  };
  var custom = [];
  switch (mode) {
    case "normal":
      /* eslint-disable */var item = {
        element: evt.item,
        newIndex: evt.newIndex,
        oldIndex: evt.oldIndex,
        parentElement: evt.from
      };
      custom = [item];
      break;
    case "swap":
      var drag = _objectSpread({
        element: evt.item,
        oldIndex: evt.oldIndex,
        newIndex: evt.newIndex
      }, parentElement);
      var swap = _objectSpread({
        element: evt.swapItem,
        oldIndex: evt.newIndex,
        newIndex: evt.oldIndex
      }, parentElement);
      custom = [drag, swap];
      break;
    case "multidrag":
      custom = evt.oldIndicies.map(function (curr, index) {
        return _objectSpread({
          element: curr.multiDragElement,
          oldIndex: curr.index,
          newIndex: evt.newIndicies[index].index
        }, parentElement);
      });
      break;
  }
  /* eslint-enable */
  var customs = $eb03e74f8f7db1f3$export$bc06a3af7dc65f53(custom, list);
  return customs;
}
function $eb03e74f8f7db1f3$export$c25cf8080bd305ec(normalized, list) {
  var a = $eb03e74f8f7db1f3$export$be2da95e6167b0bd(normalized, list);
  var b = $eb03e74f8f7db1f3$export$eca851ee65ae17e4(normalized, a);
  return b;
}
function $eb03e74f8f7db1f3$export$be2da95e6167b0bd(normalized, list) {
  var newList = _toConsumableArray(list);
  normalized.concat().reverse().forEach(function (curr) {
    return newList.splice(curr.oldIndex, 1);
  });
  return newList;
}
function $eb03e74f8f7db1f3$export$eca851ee65ae17e4(normalized, list, evt, clone) {
  var newList = _toConsumableArray(list);
  normalized.forEach(function (curr) {
    var newItem = clone && evt && clone(curr.item, evt);
    newList.splice(curr.newIndex, 0, newItem || curr.item);
  });
  return newList;
}
function $eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt) {
  if (evt.oldIndicies && evt.oldIndicies.length > 0) return "multidrag";
  if (evt.swapItem) return "swap";
  return "normal";
}
function $eb03e74f8f7db1f3$export$bc06a3af7dc65f53(inputs, list) {
  var normalized = inputs.map(function (curr) {
    return _objectSpread(_objectSpread({}, curr), {}, {
      item: list[curr.oldIndex]
    });
  }).sort(function (a, b) {
    return a.oldIndex - b.oldIndex;
  });
  return normalized;
}
function $eb03e74f8f7db1f3$export$7553c81e62e31b7e(props) {
  /* eslint-disable */var
    // react sortable props
    list = props.list,
    setList = props.setList,
    children = props.children,
    tag = props.tag,
    style = props.style,
    className = props.className,
    clone = props.clone,
    // sortable options that have methods we want to overwrite
    onAdd = props.onAdd,
    onChange = props.onChange,
    onChoose = props.onChoose,
    onClone = props.onClone,
    onEnd = props.onEnd,
    onFilter = props.onFilter,
    onRemove = props.onRemove,
    onSort = props.onSort,
    onStart = props.onStart,
    onUnchoose = props.onUnchoose,
    onUpdate = props.onUpdate,
    onMove = props.onMove,
    onSpill = props.onSpill,
    onSelect = props.onSelect,
    onDeselect = props.onDeselect,
    options = _objectWithoutProperties(props, _excluded);
  /* eslint-enable */
  return options;
}

/** Holds a global reference for which react element is being dragged */ // @todo - use context to manage this. How does one use 2 different providers?
var $7fe8e3ea572bda7a$var$store = {
  dragging: null
};
var $7fe8e3ea572bda7a$export$11bbed9ee0012c13 = /*#__PURE__*/function (_$8zHUo$react$Compone) {
  "use strict";

  _inherits($7fe8e3ea572bda7a$export$11bbed9ee0012c13, _$8zHUo$react$Compone);
  var _super = _createSuper($7fe8e3ea572bda7a$export$11bbed9ee0012c13);
  function $7fe8e3ea572bda7a$export$11bbed9ee0012c13(props) {
    var _this;
    _classCallCheck(this, $7fe8e3ea572bda7a$export$11bbed9ee0012c13);
    _this = _super.call(this, props);
    // @todo forward ref this component
    _this.ref = /*#__PURE__*/$8zHUo$react.createRef();
    // make all state false because we can't change sortable unless a mouse gesture is made.
    var newList = _toConsumableArray(props.list).map(function (item) {
      return Object.assign(item, {
        chosen: false,
        selected: false
      });
    });
    props.setList(newList, _this.sortable, $7fe8e3ea572bda7a$var$store);
    $parcel$interopDefault($8zHUo$tinyinvariant)(
    //@ts-expect-error: Doesn't exist. Will deprecate soon.
    !props.plugins, "\nPlugins prop is no longer supported.\nInstead, mount it with \"Sortable.mount(new MultiDrag())\"\nPlease read the updated README.md at https://github.com/SortableJS/react-sortablejs.\n      ");
    return _this;
  }
  _createClass($7fe8e3ea572bda7a$export$11bbed9ee0012c13, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.ref.current === null) return;
      var newOptions = this.makeOptions();
      $parcel$interopDefault($8zHUo$sortablejs).create(this.ref.current, newOptions);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.disabled !== this.props.disabled && this.sortable) this.sortable.option("disabled", this.props.disabled);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        tag = _this$props.tag,
        style = _this$props.style,
        className = _this$props.className,
        id = _this$props.id;
      var classicProps = {
        style: style,
        className: className,
        id: id
      };
      // if no tag, default to a `div` element.
      var newTag = !tag || tag === null ? "div" : tag;
      return /*#__PURE__*/$8zHUo$react.createElement(newTag, _objectSpread({
        // @todo - find a way (perhaps with the callback) to allow AntD components to work
        ref: this.ref
      }, classicProps), this.getChildren());
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        dataIdAttr = _this$props2.dataIdAttr,
        _this$props2$selected = _this$props2.selectedClass,
        selectedClass = _this$props2$selected === void 0 ? "sortable-selected" : _this$props2$selected,
        _this$props2$chosenCl = _this$props2.chosenClass,
        chosenClass = _this$props2$chosenCl === void 0 ? "sortable-chosen" : _this$props2$chosenCl,
        _this$props2$dragClas = _this$props2.dragClass,
        dragClass = _this$props2$dragClas === void 0 ? "sortable-drag" : _this$props2$dragClas,
        _this$props2$fallback = _this$props2.fallbackClass,
        fallbackClass = _this$props2$fallback === void 0 ? "sortable-falback" : _this$props2$fallback,
        _this$props2$ghostCla = _this$props2.ghostClass,
        ghostClass = _this$props2$ghostCla === void 0 ? "sortable-ghost" : _this$props2$ghostCla,
        _this$props2$swapClas = _this$props2.swapClass,
        swapClass = _this$props2$swapClas === void 0 ? "sortable-swap-highlight" : _this$props2$swapClas,
        _this$props2$filter = _this$props2.filter,
        filter = _this$props2$filter === void 0 ? "sortable-filter" : _this$props2$filter,
        list = _this$props2.list;
      // if no children, don't do anything.
      if (!children || children == null) return null;
      var dataid = dataIdAttr || "data-id";
      /* eslint-disable-next-line */
      return $8zHUo$react.Children.map(children, function (child, index) {
        var _objectSpread2, _$8zHUo$react$cloneEl;
        if (child === undefined) return undefined;
        var item = list[index] || {};
        var prevClassName = child.props.className;
        // @todo - handle the function if avalable. I don't think anyone will be doing this soon.
        var filtered = typeof filter === "string" && _defineProperty({}, filter.replace(".", ""), !!item.filtered);
        var className = $parcel$interopDefault($8zHUo$classnames)(prevClassName, _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, selectedClass, item.selected), _defineProperty(_objectSpread2, chosenClass, item.chosen), _objectSpread2), filtered));
        return /*#__PURE__*/$8zHUo$react.cloneElement(child, (_$8zHUo$react$cloneEl = {}, _defineProperty(_$8zHUo$react$cloneEl, dataid, child.key), _defineProperty(_$8zHUo$react$cloneEl, "className", className), _$8zHUo$react$cloneEl));
      });
    }
    /** Appends the `sortable` property to this component */
  }, {
    key: "sortable",
    get: function get() {
      var el = this.ref.current;
      if (el === null) return null;
      var key = Object.keys(el).find(function (k) {
        return k.includes("Sortable");
      });
      if (!key) return null;
      //@ts-expect-error: fix me.
      return el[key];
    }
    /** Converts all the props from `ReactSortable` into the `options` object that `Sortable.create(el, [options])` can use. */
  }, {
    key: "makeOptions",
    value: function makeOptions() {
      var _this2 = this;
      var DOMHandlers = ["onAdd", "onChoose", "onDeselect", "onEnd", "onRemove", "onSelect", "onSpill", "onStart", "onUnchoose", "onUpdate"];
      var NonDOMHandlers = ["onChange", "onClone", "onFilter", "onSort"];
      var newOptions = $eb03e74f8f7db1f3$export$7553c81e62e31b7e(this.props);
      DOMHandlers.forEach(function (name) {
        return newOptions[name] = _this2.prepareOnHandlerPropAndDOM(name);
      });
      NonDOMHandlers.forEach(function (name) {
        return newOptions[name] = _this2.prepareOnHandlerProp(name);
      });
      /** onMove has 2 arguments and needs to be handled seperately. */
      var onMove1 = function onMove1(evt, originalEvt) {
        var onMove = _this2.props.onMove;
        var defaultValue = evt.willInsertAfter || -1;
        if (!onMove) return defaultValue;
        var result = onMove(evt, originalEvt, _this2.sortable, $7fe8e3ea572bda7a$var$store);
        if (typeof result === "undefined") return false;
        return result;
      };
      return _objectSpread(_objectSpread({}, newOptions), {}, {
        onMove: onMove1
      });
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop & an `on[Handler]` ReactSortable method.  */
  }, {
    key: "prepareOnHandlerPropAndDOM",
    value: function prepareOnHandlerPropAndDOM(evtName) {
      var _this3 = this;
      return function (evt) {
        // call the component prop
        _this3.callOnHandlerProp(evt, evtName);
        // calls state change
        //@ts-expect-error: until @types multidrag item is in
        _this3[evtName](evt);
      };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop */
  }, {
    key: "prepareOnHandlerProp",
    value: function prepareOnHandlerProp(evtName) {
      var _this4 = this;
      return function (evt) {
        // call the component prop
        _this4.callOnHandlerProp(evt, evtName);
      };
    }
    /** Calls the `props.on[Handler]` function */
  }, {
    key: "callOnHandlerProp",
    value: function callOnHandlerProp(evt, evtName) {
      var propEvent = this.props[evtName];
      if (propEvent) propEvent(evt, this.sortable, $7fe8e3ea572bda7a$var$store);
    }
    // SORTABLE DOM HANDLING
  }, {
    key: "onAdd",
    value: function onAdd(evt) {
      var _this$props3 = this.props,
        list = _this$props3.list,
        setList = _this$props3.setList,
        clone = _this$props3.clone;
      /* eslint-disable-next-line */
      var otherList = _toConsumableArray($7fe8e3ea572bda7a$var$store.dragging.props.list);
      var customs = $eb03e74f8f7db1f3$export$4655efe700f887a(evt, otherList);
      $eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
      var newList = $eb03e74f8f7db1f3$export$eca851ee65ae17e4(customs, list, evt, clone).map(function (item) {
        return Object.assign(item, {
          selected: false
        });
      });
      setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
    }
  }, {
    key: "onRemove",
    value: function onRemove(evt) {
      var _this5 = this;
      var _this$props4 = this.props,
        list = _this$props4.list,
        setList = _this$props4.setList;
      var mode = $eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt);
      var customs = $eb03e74f8f7db1f3$export$4655efe700f887a(evt, list);
      $eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
      var newList = _toConsumableArray(list);
      // remove state if not in clone mode. otherwise, keep.
      if (evt.pullMode !== "clone") newList = $eb03e74f8f7db1f3$export$be2da95e6167b0bd(customs, newList);else {
        // switch used to get the clone
        var customClones = customs;
        switch (mode) {
          case "multidrag":
            customClones = customs.map(function (item, index) {
              return _objectSpread(_objectSpread({}, item), {}, {
                element: evt.clones[index]
              });
            });
            break;
          case "normal":
            customClones = customs.map(function (item) {
              return _objectSpread(_objectSpread({}, item), {}, {
                element: evt.clone
              });
            });
            break;
          case "swap":
          default:
            $parcel$interopDefault($8zHUo$tinyinvariant)(true, "mode \"".concat(mode, "\" cannot clone. Please remove \"props.clone\" from <ReactSortable/> when using the \"").concat(mode, "\" plugin"));
        }
        $eb03e74f8f7db1f3$export$77f49a256021c8de(customClones);
        // replace selected items with cloned items
        customs.forEach(function (curr) {
          var index = curr.oldIndex;
          /* eslint-disable-next-line */
          var newItem = _this5.props.clone(curr.item, evt);
          newList.splice(index, 1, newItem);
        });
      }
      // remove item.selected from list
      newList = newList.map(function (item) {
        return Object.assign(item, {
          selected: false
        });
      });
      setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
    }
  }, {
    key: "onUpdate",
    value: function onUpdate(evt) {
      var _this$props5 = this.props,
        list = _this$props5.list,
        setList = _this$props5.setList;
      var customs = $eb03e74f8f7db1f3$export$4655efe700f887a(evt, list);
      $eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
      $eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
      var newList = $eb03e74f8f7db1f3$export$c25cf8080bd305ec(customs, list);
      return setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
    }
  }, {
    key: "onStart",
    value: function onStart() {
      $7fe8e3ea572bda7a$var$store.dragging = this;
    }
  }, {
    key: "onEnd",
    value: function onEnd() {
      $7fe8e3ea572bda7a$var$store.dragging = null;
    }
  }, {
    key: "onChoose",
    value: function onChoose(evt) {
      var _this$props6 = this.props,
        list = _this$props6.list,
        setList = _this$props6.setList;
      var newList = list.map(function (item, index) {
        var newItem = item;
        if (index === evt.oldIndex) newItem = Object.assign(item, {
          chosen: true
        });
        return newItem;
      });
      setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
    }
  }, {
    key: "onUnchoose",
    value: function onUnchoose(evt) {
      var _this$props7 = this.props,
        list = _this$props7.list,
        setList = _this$props7.setList;
      var newList = list.map(function (item, index) {
        var newItem = item;
        if (index === evt.oldIndex) newItem = Object.assign(newItem, {
          chosen: false
        });
        return newItem;
      });
      setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
    }
  }, {
    key: "onSpill",
    value: function onSpill(evt) {
      var _this$props8 = this.props,
        removeOnSpill = _this$props8.removeOnSpill,
        revertOnSpill = _this$props8.revertOnSpill;
      if (removeOnSpill && !revertOnSpill) $eb03e74f8f7db1f3$export$1d0aa160432dfea5(evt.item);
    }
  }, {
    key: "onSelect",
    value: function onSelect(evt) {
      var _this$props9 = this.props,
        list = _this$props9.list,
        setList = _this$props9.setList;
      var newList = list.map(function (item) {
        return Object.assign(item, {
          selected: false
        });
      });
      evt.newIndicies.forEach(function (curr) {
        var index = curr.index;
        if (index === -1) {
          console.log("\"".concat(evt.type, "\" had indice of \"").concat(curr.index, "\", which is probably -1 and doesn't usually happen here."));
          console.log(evt);
          return;
        }
        newList[index].selected = true;
      });
      setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
    }
  }, {
    key: "onDeselect",
    value: function onDeselect(evt) {
      var _this$props10 = this.props,
        list = _this$props10.list,
        setList = _this$props10.setList;
      var newList = list.map(function (item) {
        return Object.assign(item, {
          selected: false
        });
      });
      evt.newIndicies.forEach(function (curr) {
        var index = curr.index;
        if (index === -1) return;
        newList[index].selected = true;
      });
      setList(newList, this.sortable, $7fe8e3ea572bda7a$var$store);
    }
  }]);
  return $7fe8e3ea572bda7a$export$11bbed9ee0012c13;
}($8zHUo$react.Component);
$7fe8e3ea572bda7a$export$11bbed9ee0012c13.defaultProps = {
  clone: function clone(item) {
    return item;
  }
};
var $faefaad95e5fcca0$exports = {};
$parcel$exportWildcard(module.exports, $faefaad95e5fcca0$exports);